import React, { FC } from 'react';
import cx from 'classnames';
import { sortBy } from 'lodash';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import none from 'file-loader!@/assets/images/none.png'; // eslint-disable-line
import fallback from 'file-loader!@/assets/images/fallback-sample.png'; // eslint-disable-line
import SampleSelector, { SampleOption } from '@/components/Common/SampleSelector';
import { type Props } from './types';
import * as styles from '../ProductConfigurator.module.scss';

const BundleOptionProductSelectorImageFinish: FC<Props> = ({
  className,
  option,
  value,
  onChange,
}) => {
  const noneOption: SampleOption = { code: null, name: i18n._(t`None`), image: none };
  const options: SampleOption[] = [
    ...sortBy(option.products, 'position').map((product) => ({
      code: product.sku,
      name: product.label || product.name,
      image: product.pim?.thumbnail?.childImageSharp?.gatsbyImageData || fallback,
    })),
  ];

  const selectedOption = options.find((o) => o.code === value);

  return (
    <SampleSelector
      className={cx(styles.samples, className)}
      options={[...(!option.isRequired ? [noneOption] : []), ...options]}
      selectedOption={selectedOption}
      onChange={(option) => onChange(option.code)}
      shouldShowCode={false}
    />
  );
};

export default BundleOptionProductSelectorImageFinish;
